import angular from 'angular';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { withProviders } from '../../../modules/core/components';
import Tax from '../../../modules/core/components/tax';
import growthbook from '../../../global/global.experiments';
// how to use for angular -> react-global-tax(
// email="test@test.com"
// plan-name="plan-default-usd-pro_monthly-v2"
// postal-code="10000"
// country-code="US"
// coupon="couponCode"
// seats="1"
// show-error-message="false"
// is-valid="callbackFunction"
// get-amount="amountTaxFunction"
// )
const InnerComponent = (props) => {
    const { email, planName, postalCode, countryCode, coupon, seats, showErrorMessage, isValid, getAmount, } = props;
    return (<GrowthBookProvider growthbook={growthbook}>
      <Tax email={email} planName={planName} postalCode={postalCode} countryCode={countryCode} coupon={coupon} seats={seats} showErrorMessage={showErrorMessage} isValid={isValid} getAmount={getAmount}/>
    </GrowthBookProvider>);
};
export default angular
    .module('doxy.common.components.reactGlobalTax', [])
    .component('reactGlobalTax', {
    template: `<div></div>`,
    bindings: {
        email: '@',
        planName: '@',
        postalCode: '@',
        countryCode: '@',
        coupon: '<',
        seats: '<',
        showErrorMessage: '<',
        isValid: '=',
        getAmount: '=',
    },
    controller: function ($element) {
        const render = () => {
            const props = {
                email: this.email,
                planName: this.planName,
                postalCode: this.postalCode,
                countryCode: this.countryCode,
                coupon: this.coupon,
                seats: Number.isInteger(this.seats) ? this.seats : 1,
                showErrorMessage: this.showErrorMessage,
                isValid: this.isValid,
                getAmount: this.getAmount,
            };
            ReactDOM.render(React.createElement(withProviders(InnerComponent), props), $element[0]);
        };
        this.$onChanges = _.debounce(render, 500);
    },
}).name;
